export default __webpack_public_path__ + "static/media/move-wiki-icon.c556c41e.svg";